import { Grid, TableContainer, Typography } from "@mui/material";
import s from '../../../../commonStyles.modules.scss'
import {useMemo, useState} from 'react'
import { useNotification } from 'hooks'
import { useLocation, useParams } from 'react-router-dom'
import { makeCoreGetFileRequest, makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { toTableRowItems } from './serializers'
import { formatErrorMessage } from 'utils/formatting'
import { columns, drawerFilters, toolbarActions } from './helpers'
import { Table } from 'components/core-ui/Table'
import { formatAndDownloadResponse } from 'utils/helpers'
import { InfoItems } from 'components/core-ui/InfoItems'

const MetiFileDetail = ({ isHistorical }) => {
  const { showNotification } = useNotification()
  const { id } = useParams()
  const location = useLocation()
  const shopCode = new URLSearchParams(location.search).get('shopCode')

  const [tableItems, setTableItems] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [infoItems, setInfoItems] = useState(null)
  const [isCSVExportLoading, setIsCSVExportLoading] = useState<boolean>(false)
  const [isExcelExportLoading, setIsExcelExportLoading] = useState<boolean>(false)

  const fetchData = async ({ order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const baseUrl = isHistorical
        ? `/shop-reception/metiIntegrationFileArchive/details/${id}`
        : `/shop-reception/metiIntegrationFile/details/${id}`

      const hasFilters = tableFilters.some(tableFilter => tableFilter.value)

      let finalUrl = toTableGETUrl({
        url: hasFilters ? `${baseUrl}/filter` : baseUrl,
        extraCustomUrlParams: [{ name: 'shopCode', value: shopCode }],
        tableFilters,
        order,
        orderBy
      })

      const response = await makeCoreGetRequest(finalUrl)

      setTableItems(toTableRowItems(response.productList))
      setInfoItems(response)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const exportFileExcel = async (tableState) => {
    setIsExcelExportLoading(true)
    const { filters, order, orderBy } = tableState
    const url = toTableGETUrl({
      url: isHistorical
        ? `/shop-reception/metiIntegrationFileArchive/detailsExport/${id}`
        : `/shop-reception/metiIntegrationFile/detailsExport/${id}`,
      tableFilters: filters,
      order,
      orderBy
    })

    try {
      const response = await makeCoreGetFileRequest(url, {
        responseType: 'blob'
      })
      formatAndDownloadResponse(response);
      setIsExcelExportLoading(false)
    } catch (error) {
      setIsExcelExportLoading(false)
      showNotification({
        message: `Error while download file. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const hasFilters = true; //always export

  const toolbar = useMemo(() => toolbarActions({
      hasFilters,
      exportFileExcel: exportFileExcel,
      isExcelExportLoading }),
    [true, 0, exportFileExcel, isCSVExportLoading, isExcelExportLoading])

  return (
    <Grid className={s.mainContainer}>
      <Typography style={{color: 'black', fontWeight: 'bold'}}>
        Fisier Meti pentru BL {infoItems?.ticketExternalId}, magazin {infoItems?.shopName}
      </Typography>

      <InfoItems
        itemsPerRow={3}
        items={[
          { name: infoItems?.depositName, label: 'Depozit sursa:' },
          { name: infoItems?.shopName, label: 'Magazin destinatie:' },
          { name: infoItems?.ticketExternalId, label: 'Bon livrare:' },
          { name: infoItems?.statusValue, label: 'Status fisier:' }
        ]}
      />

      <TableContainer style={{ marginTop: 15 }}>
        <Table
          hideCheckbox
          order="asc"
          orderBy="prodCode"
          columns={columns}
          items={tableItems}
          fetchData={fetchData}
          isLoading={isLoading}
          shouldRefreshData={shouldRefreshData}
          setShouldRefreshData={setShouldRefreshData}
          filters={drawerFilters}
          toolbarActions={toolbar}
          disablePagination
          hasStickyHeader
          maxHeight={600}
        />
      </TableContainer>
    </Grid>
  )
}

export default MetiFileDetail
